export var CANCELLATION_EARLY = 'early';
export var CANCELLATION_LATE = 'late';
export var CANCELLATION_FLYWHEEL = 'FLYWHEEL';